import {
  Application,
  FeathersService,
  Query,
  Service
} from "@feathersjs/feathers";
import {
  makeObservable,
  reaction,
  runInAction,
  set
} from "mobx";
import client from "../feathers";
import { RootStore, BaseDataStore } from ".";
import { File } from "../models";
import { DataType, IFile, Services, FileData } from "../types";
import toast from "react-hot-toast";
import i18next from 'src/i18n';

export class FileStore extends BaseDataStore<File, IFile> {
  protected readonly file_service: FeathersService<
    Application<IFile>,
    Service<IFile>
  > = client.service(Services.File);

  constructor(readonly rootStore: RootStore) {
    super(rootStore, File.create, DataType.File);

    makeObservable(this, {
    });
    this.file_service.on("created", (data: IFile) => {
      runInAction(() => {
        set(this.container, data.id, File.create(data));
        this.notify(data);
      });
    });
  }

  /*******************************************************************************************************************************************
   * Overwrites
   ********************************************************************************************************************************************/
  init() {
    super.init();
    // Load initial files for items
    reaction(() => this.rootStore.getActiveItem, () => {
      if (this.rootStore.getActiveItem?.id == null) this.container = {};
      else this.loadItems(this.getCurFilter());
    }, { name: "file_onActive_load" });

    if (this.rootStore.routingStore.getPathName.endsWith('documents')) {
      this.loadItems(this.getDocumentViewFilter());
    }

    reaction(() => this.rootStore.routingStore.getPathName, () => {
      if (this.rootStore.routingStore.getPathName.endsWith('documents')) {
        this.loadItems(this.getDocumentViewFilter());
      }
    })
  }


  protected getCurFilter = (): Query => ({
    'file.item_id': this.rootStore.getActiveItem.id
  });

  protected getDocumentViewFilter = (): Query => ({
    "file.room_id": this.rootStore.authStore.getCurRoomID
  });

  /*******************************************************************************************************************************************
   * Getter
   ********************************************************************************************************************************************/
  get getItems(): File[] {
    return Object.values(this.container);
  }

  /*******************************************************************************************************************************************
   * Setter
   ********************************************************************************************************************************************/


  /*******************************************************************************************************************************************
   * Actions
   ********************************************************************************************************************************************/

  // creating a "toast" and says that user X file on item #Y
  notify = (data: IFile) => {
    const user = this.rootStore.userStore.getItemByID(data.created_by);
    if (this.rootStore.getActiveItem) {
      toast.success(i18next.t('successfully_uploaded_file_to_item', { number: this.rootStore.getActiveItem.number }))
    } else {
      toast.success(i18next.t('file_successfully_uploaded_to_room', { room_id: this.rootStore.authStore.getCurRoomID }))
    }
  };

  public addFileToItem = async (fileData: FileData) => {
    const { id: item_id, room_id } = this.rootStore.getActiveItem;
    const workspace_id = this.rootStore.authStore.getCurWorkspaceID;
    try {
      const file = File.create({
        ...fileData,
        item_id,
        room_id,
        workspace_id
      });
      await file.upload();
    } catch (error) {
      console.error('Failed to upload file to item', error);
    }
  };

  public removeFileFromItem = async (file: File) => {
    const { number: number } = this.rootStore.getActiveItem;
    try {
      await file.remove();
      toast.success(i18next.t('successfully_removed_file_from_item', { number: number }))

    } catch (error) {
      console.error('Failed to remove file from item', error);
      toast.success(i18next.t('error_remove_file_from_item', { number: number }))
    }
  };

  public addFileToRoom = async (fileData: FileData) => {
    const workspace_id = this.rootStore.authStore.getCurWorkspaceID;
    const room_id = this.rootStore.authStore.getCurRoomID;
    console.log({
      ...fileData,
      room_id,
      workspace_id
    });
    try {
      const file = File.create({
        ...fileData,
        room_id,
        workspace_id,
        item_id: null,
      });
      await file.upload();
    } catch (error) {
      console.error('Failed to upload file to item', error);
    }
  };

  public removeFileFromRoom = async (file: File) => {
    const room_id = this.rootStore.authStore.getCurRoomID;
    try {
      await file.remove();
      toast.success(i18next.t('file_successfully_uploaded_to_room', { room_id: room_id }))
    } catch (error) {
      console.error('Failed to remove file from room', error);
      toast.success(i18next.t('error_upload_file_to_room', { room_id: room_id }))
    }
  };
}
